import {
  listRsvp as publicListRsvp,
  queryRsvp as publicQueryRsvp,
  getRsvp as publicGetRsvp,
  createRsvp as publicCreateRsvp,
  updateRsvp as publicUpdateRsvp,
  bulkUpdateRsvp as publicBulkUpdateRsvp,
  deleteRsvp as publicDeleteRsvp,
  checkInRsvp as publicCheckInRsvp,
  deleteRsvpCheckIn as publicDeleteRsvpCheckIn,
} from './events-v1-rsvp-rsvp.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onRsvpCreated as publicOnRsvpCreated } from './events-v1-rsvp-rsvp.public.js';
import { onRsvpDeleted as publicOnRsvpDeleted } from './events-v1-rsvp-rsvp.public.js';
import { onRsvpUpdated as publicOnRsvpUpdated } from './events-v1-rsvp-rsvp.public.js';

export const listRsvp: MaybeContext<
  BuildRESTFunction<typeof publicListRsvp> & typeof publicListRsvp
> = /*#__PURE__*/ createRESTModule(publicListRsvp);
export const queryRsvp: MaybeContext<
  BuildRESTFunction<typeof publicQueryRsvp> & typeof publicQueryRsvp
> = /*#__PURE__*/ createRESTModule(publicQueryRsvp);
export const getRsvp: MaybeContext<
  BuildRESTFunction<typeof publicGetRsvp> & typeof publicGetRsvp
> = /*#__PURE__*/ createRESTModule(publicGetRsvp);
export const createRsvp: MaybeContext<
  BuildRESTFunction<typeof publicCreateRsvp> & typeof publicCreateRsvp
> = /*#__PURE__*/ createRESTModule(publicCreateRsvp);
export const updateRsvp: MaybeContext<
  BuildRESTFunction<typeof publicUpdateRsvp> & typeof publicUpdateRsvp
> = /*#__PURE__*/ createRESTModule(publicUpdateRsvp);
export const bulkUpdateRsvp: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateRsvp> & typeof publicBulkUpdateRsvp
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateRsvp);
export const deleteRsvp: MaybeContext<
  BuildRESTFunction<typeof publicDeleteRsvp> & typeof publicDeleteRsvp
> = /*#__PURE__*/ createRESTModule(publicDeleteRsvp);
export const checkInRsvp: MaybeContext<
  BuildRESTFunction<typeof publicCheckInRsvp> & typeof publicCheckInRsvp
> = /*#__PURE__*/ createRESTModule(publicCheckInRsvp);
export const deleteRsvpCheckIn: MaybeContext<
  BuildRESTFunction<typeof publicDeleteRsvpCheckIn> &
    typeof publicDeleteRsvpCheckIn
> = /*#__PURE__*/ createRESTModule(publicDeleteRsvpCheckIn);
/** @deprecated */
export const onRsvpCreated: BuildEventDefinition<typeof publicOnRsvpCreated> &
  typeof publicOnRsvpCreated = createEventModule(publicOnRsvpCreated);
/** @deprecated */
export const onRsvpDeleted: BuildEventDefinition<typeof publicOnRsvpDeleted> &
  typeof publicOnRsvpDeleted = createEventModule(publicOnRsvpDeleted);
/** @deprecated */
export const onRsvpUpdated: BuildEventDefinition<typeof publicOnRsvpUpdated> &
  typeof publicOnRsvpUpdated = createEventModule(publicOnRsvpUpdated);

export {
  SubdivisionType,
  RsvpStatus,
  RsvpFieldset,
  RsvpTag,
  WebhookIdentityType,
} from './events-v1-rsvp-rsvp.universal.js';
export {
  Rsvp,
  FormResponse,
  InputValue,
  FormattedAddress,
  Address,
  AddressStreetOneOf,
  StreetAddress,
  AddressLocation,
  Subdivision,
  StandardDetails,
  Guest,
  CheckIn,
  ListRsvpRequest,
  ListRsvpResponse,
  FacetCounts,
  RsvpFacets,
  RsvpFacetCounts,
  Counts,
  QueryRsvpRequest,
  QueryRsvpResponse,
  GetRsvpRequest,
  GetRsvpResponse,
  CreateRsvpRequest,
  ModificationOptions,
  CreateRsvpResponse,
  CalendarLinks,
  RsvpCreated,
  OnlineConferencingLogin,
  UpdateRsvpRequest,
  UpdateRsvpResponse,
  RsvpUpdated,
  BulkUpdateRsvpRequest,
  BulkUpdateRsvpResponse,
  DeleteRsvpRequest,
  DeleteRsvpResponse,
  RsvpDeleted,
  CheckInRsvpRequest,
  CheckInRsvpResponse,
  DeleteRsvpCheckInRequest,
  DeleteRsvpCheckInResponse,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  RsvpCreatedEnvelope,
  RsvpDeletedEnvelope,
  RsvpUpdatedEnvelope,
  ListRsvpOptions,
  QueryRsvpOptions,
  GetRsvpOptions,
  CreateRsvpOptions,
  UpdateRsvpOptions,
  BulkUpdateRsvpOptions,
  DeleteRsvpOptions,
  CheckInRsvpOptions,
  DeleteRsvpCheckInOptions,
} from './events-v1-rsvp-rsvp.universal.js';
export {
  SubdivisionTypeWithLiterals,
  RsvpStatusWithLiterals,
  RsvpFieldsetWithLiterals,
  RsvpTagWithLiterals,
  WebhookIdentityTypeWithLiterals,
} from './events-v1-rsvp-rsvp.universal.js';
